import { render } from "./buyer-product-view.vue?vue&type=template&id=450fffc2&scoped=true"
import script from "./buyer-product-view.vue?vue&type=script&lang=js"
export * from "./buyer-product-view.vue?vue&type=script&lang=js"

import "./buyer-product-view.vue?vue&type=style&index=0&id=450fffc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450fffc2"]])

export default __exports__